/**
 * Issue #146: the caller's own minetwin site membership, from the
 * `my_user_sites` view (already in the main subscription batch — the
 * portal just never read it before this).
 *
 * `isReady` follows the subscription so pages can avoid flashing the
 * not-a-member state during the initial load: gate only when
 * `isReady && !isMember`.
 */
import { useTable } from 'spacetimedb/react';
import { tables as minetwinTables } from '@sdk/minetwin';
import { hasSiteMembership } from '@/lib/siteMembership';

export function useMySiteMembership(projectId: string): {
  isMember: boolean;
  isReady: boolean;
} {
  const [rows, isReady] = useTable('minetwin', minetwinTables.my_user_sites);
  return { isMember: hasSiteMembership(rows, projectId), isReady };
}
